import { leadStories } from '@/mocks/home';

export default function HeadlineSection() {
  const [lead, ...rest] = leadStories;

  return (
    <section id="today-headline" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b-2 border-foreground-950 pb-3">
          <div className="flex items-end gap-3">
            <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">今日重磅</h3>
            <span className="mb-1 text-xs text-foreground-500">编辑部每日筛选 · 只留最硬的瓜</span>
          </div>
          <a href="#evidence" className="flex cursor-pointer items-center gap-1 text-sm text-primary-600 hover:text-primary-700">
            查看完整榜单
            <i className="ri-arrow-right-s-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <article className="group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:col-span-2">
            <div className="h-64 w-full overflow-hidden md:h-80">
              <img
                src={lead.image}
                alt={lead.title}
                title="黑料大瓜 今日重磅 最新爆料"
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="mb-3 flex flex-wrap items-center gap-2">
                <span className="rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">{lead.badge}</span>
                <span className="rounded-md bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900">阅读 328 万</span>
                <span className="text-xs text-foreground-500">{lead.meta}</span>
              </div>
              <h4 className="font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                {lead.title}
              </h4>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
              <div className="mt-5 flex flex-wrap items-center gap-5 border-t border-background-200 pt-4 text-sm text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-chat-3-line" />
                  {lead.comments.toLocaleString()} 条讨论
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-share-forward-line" />
                  转发 1.2 万
                </span>
                <span className="ml-auto flex items-center gap-1.5 text-primary-600">
                  查看完整爆料
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4">
            {rest.map((item, i) => (
              <article
                key={item.id}
                className="group flex-1 cursor-pointer rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50 md:p-5"
              >
                <div className="mb-3 flex items-center gap-2">
                  <span className="flex h-6 w-6 items-center justify-center rounded-md bg-foreground-950 text-xs font-bold text-background-50">
                    {i + 2}
                  </span>
                  <span
                    className={`rounded-md px-2 py-0.5 text-xs font-medium ${
                      i === 0 ? 'bg-secondary-100 text-secondary-900' : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {item.badge}
                  </span>
                  <span className="ml-auto text-xs text-foreground-500">{item.meta}</span>
                </div>
                <h4 className="text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h4>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}